import { render, staticRenderFns } from "./dashboard-tile.vue?vue&type=template&id=20abcc70&"
import script from "./dashboard-tile.vue?vue&type=script&lang=ts&"
export * from "./dashboard-tile.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-tile.vue?vue&type=style&index=0&id=20abcc70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports